import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Header from '../../layout/Header.jsx';
import FormCompetition from '../../forms/competition/FormCompetition.jsx';

const PageCompetition = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({
        url: `api/quiz/competitions/${_id}`,
      });
    }
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Competitions' },
  ];

  return (
    <>
      {_id === 'new' ? (
        <div>
          <Header breadcrumb={breadcrumb}>Create New</Header>
          <FormCompetition />
        </div>
      ) : (
        <PageHttp res={res}>
          {(doc) => (
            <>
              <Header breadcrumb={breadcrumb}>Editor</Header>
              <FormCompetition competition={doc} />
            </>
          )}
        </PageHttp>
      )}
    </>
  );
};

export default PageCompetition;
